import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: "/",
        redirect: "/index"
    }, {
        path: '/register',
        component: () => import('../views/register.vue')
    },{
        path: '/login',
        component: () => import('../views/login.vue')
    },
    {
        path: '/index',
        component: () => import('../views/index.vue'),
        redirect: '/home',
        children: [{
                path: '/home',
                component: () => import('../views/home.vue')
            },
            {
                path: '/redeem',
                component: () => import('../views/redeem.vue')
            },
            {
                path: '/package',
                component: () => import('../views/package.vue')
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router